/**
 * Created by Stanfly on 30.01.2017.
 */
function getResizedCanvas(canvas,newWidth,newHeight) {
    var tmpCanvas = document.createElement('canvas');
    tmpCanvas.width = newWidth;
    tmpCanvas.height = newHeight;

    var ctx = tmpCanvas.getContext('2d');
    ctx.drawImage(canvas,0,0,canvas.width,canvas.height,0,0,newWidth,newHeight);

    return tmpCanvas;
}
function mainLoaderStart(){
    $('body').addClass("mainLoader");
}
function mainLoaderStop(){
    $('body').removeClass("mainLoader");
}
$.fn.startLoader = function (){
    this.addClass('loader');
};
$.fn.stopLoader = function (){
    this.removeClass('loader');
};
$.fn.toggleLoader = function (){
    this.toggleClass('loader');
};
function bsAlert(header,text,type){
    $('body').append('<div class="alert-wrap"><div class="alert alert-'+type+' alert-dismissible fade in" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true"><span class="glyphicon glyphicon-remove"></span></span></button> ' +
        '<h4>'+header+'</h4> ' +
        '<p>'+text+'</p></div></div>');
    $('.alert').alert();
    setTimeout(function(){
        $('.alert-wrap').fadeOut( "slow", function() {
            // Animation complete.
            $('.alert-wrap').detach();
        });
    },5000);
}

function scrollTo(selector){
    if ( $(selector).length ) {
        $('html, body').animate({
            scrollTop: $(selector).offset().top - 50
        }, 500);
    }
}
function accent(selector){
    if ( $(selector).length ) {
        $(".accented").removeClass("accented");
        $(selector).addClass("accented");
    }
}

function checkRequiredInputs() {
    var flag = true;
    $('input').each(function (i, input) {
        input = $(input);
        if (input[0].hasAttribute("required") && input.val().trim() == "") {
            notValid('Заполните обязательные поля', "#"+input.attr("id"), "#"+input.attr("id"));
            flag = false;
            return false;
        }
    });
    return flag;
}
function notValid(msg, scrollToSelector, focusSelector, accentSelector){
    bsAlert('Не заполнены обязательные поля',msg, 'danger');
    scrollTo(scrollToSelector);
    if ( $(focusSelector).length) {
        $(focusSelector).focus();
    }
    if(accentSelector){
        if ( $(accentSelector).length) {
            accent(accentSelector);
        }
    }
}
function unixtime(date){
    return parseInt(new Date(date).getTime()/1000)
}

function prepareURLstring(string){
    string = string.trim();
    if (string != "") {
        if (string.indexOf('http://') != 0  && string.indexOf('https://') != 0){
            string = "http://" + string;
        }
        if (string[string.length-1] != "/"){
            string = string + "/"
        }
    }
    return string;
}

$.fn.prepareURLs = function (){
    this.each(function (){
        var _this = $(this);
        _this.val(prepareURLstring(_this.val()));
    })
};

function checkPhoneValid(phone){
    return new RegExp("[+]([\\d]{1})[ ][(]([\\d]{3})[)][ ]([\\d]{3})[-]([\\d]{4})").test(phone);
}

function viewConfirmModal(options){
    viewConfirmModal_onConfirm = function(){
        event.preventDefault();
        options.onConfirm();
        viewConfirmModal_destroyModal();
    };
    viewConfirmModal_destroyModal = function(){
        $('#confirmModal').modal('hide');
        setTimeout(function(){
            $('#confirmModal').detach();
        },1000);
    };
    $('body').append('\
        <div class="modal fade" id="confirmModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">\
            <div class="modal-dialog" role="document">\
                <div class="modal-content">\
                    <div class="modal-header">\
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\
                        <h4 class="modal-title" id="myModalLabel">Подтвердите действие</h4>\
                    </div>\
                    <div class="modal-body"><strong>Внимание!</strong>' + options.text + '</div>\
                    <div class="modal-footer">\
                        <button type="button" class="btn btn-default" data-dismiss="modal" onclick="viewConfirmModal_destroyModal();">Отмена</button>\
                        <a class="btn btn-danger" href="#" onclick="viewConfirmModal_onConfirm()">'+options.confirmButtonText+'</a>\
                    </div>\
                </div>\
            </div>\
        </div>\
        <script>\
            $("#confirmModal").modal("show");\
        </script>\
    ')
}